import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function Register() {
  return (
    <div className="app-bg grain min-h-screen flex items-center justify-center p-4 relative z-10">
      <div className="w-full max-w-md card p-8 fade-in text-center" data-testid="registration-closed">
        <div className="w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 mx-auto flex items-center justify-center mb-4">
          <Lock size={24} className="text-amber-300"/>
        </div>
        <h2 className="font-display text-2xl font-bold mb-2">Registrierung geschlossen</h2>
        <p className="text-slate-400 text-sm mb-5 leading-relaxed">
          Dieses Portal arbeitet nur mit vom Administrator angelegten Konten. Bitte wenden Sie sich an Ihren Ansprechpartner, um einen Zugang zu erhalten.
        </p>
        <Link to="/login" className="btn-primary w-full justify-center" data-testid="back-to-login-link">Zurück zur Anmeldung</Link>
      </div>
    </div>
  );
}
